module.exports = __webpack_public_path__ + "img/makerTitle.f3705650.jpg";